import React, { Suspense, useState } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
//Styles
import './App.css';
//Routing/History/Services
import { userLogin } from './services/coa-authorization';
import { StateProvider } from './services/State'; //should be able to get from NPM but microServices aren't sharing cookie
//Material-ui layout needs
import { StyledEngineProvider, ThemeProvider, createTheme } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';
//Components
import { SnackbarProvider } from 'notistack';
import AppSkeleton from './components/AppSkeleton';
import ScrollToTop from './components/ScrollToTop';
//Utilities
import { coaFetch } from './services/coa-fetch';
//Content Pages
import HomePage from './pages/home';
import NotFoundPage from './pages/404';
const PressReleasesHomePage = React.lazy(() => import('./pages/PressReleases/home'));
const EditPage = React.lazy(() => import('./pages/PressReleases/edit'));
const ListPage = React.lazy(() => import('./pages/PressReleases/list'));
const Podcasts = React.lazy(() => import('./pages/Podcasts'));
const Publications = React.lazy(() => import('./pages/Publications'));
const Calendars = React.lazy(() => import('./pages/Calendars'));
//const PermissionsPage = React.lazy(() => import('./pages/Permissions'));

//Layout styles
const theme = createTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: { main: '#03a9f4' }, //lightblue from @mui/material/colors/
    secondary: { main: '#ff9800' }, //orange
  },
});


function App() {
  const [pages, setPages] = useState([]);
  // TODO - move out to an appStore.js file?
  // TODO - rewrite `reducer` function in State.js to also update localStorage?
  // TODO - perhaps make a way to update localStorage without saving the data for local timeouts?
  const STORES = {
    CACHED_LISTS: 'pressReleaseLists',
    CACHED_USER: 'userProfile',
  }
  const initialState = {
    pressReleaseLists: JSON.parse(localStorage.getItem(STORES.CACHED_LISTS)) || [],
    userProfile: JSON.parse(localStorage.getItem(STORES.CACHED_USER)) || {"name":{"fullName":"","firstName":"","lastName":""},"email":"","phone":null,"department":null,"title":null,"employeeNumber":null,"userPrincipalName":"","roles":[],"modules":[]},
  };
  const init = async () => {
    // TODO - make this a service which refreshes localStore items?
    let pressReleaseLists = fetch('https://api2.auburnalabama.org/pressrelease/list', { credentials: 'include' })
                              .then((response) => { 
                                  if (response.ok) return response.json(); 
                              })
                              .then((lists) => {
                                  localStorage.setItem(STORES.CACHED_LISTS, JSON.stringify(lists));
                                  return lists; //could do a check so it doesn't rerender when cached list is the same as returned list... actually docs say this happens automagically
                              });
    let userProfile = userLogin()
                        .then((user) => {
                          if (user.canPublish === undefined) {
                            return fetch('https://api2.auburnalabama.org/pressrelease/canIPublish', { credentials: 'include' })
                              .then((response) => { 
                                const modules = [];
                                const pages = [
                                  { name: 'Home', path: '/', module: ''},
                                  { name: 'Press Releases', path: '/press-release-editor', module: ''},
                                  //{ name: 'Custom Reports', path: '/reports', module: 'POLICE_ACTIVITY_REPORT'},
                                  { name: 'Podcasts', path: '/podcast-editor', module: ''},
                                  { name: 'Publications', path: '/publication-editor', module: ''},
                                  { name: 'Calendars', path: '/calendar-editor', module: ''}
                                ];
                                setPages(pages.filter((page) => (!page.module || modules.indexOf(page.module) !== -1)));
                                return {...user, modules, canPublish: response.ok}; 
                              })
                              .catch(() => { 
                                const modules = [];
                                const pages = [
                                  { name: 'Home', path: '/', module: ''},
                                  { name: 'Press Releases', path: '/press-release-editor', module: ''},
                                  //{ name: 'Custom Reports', path: '/reports', module: 'POLICE_ACTIVITY_REPORT'},
                                  { name: 'Podcasts', path: '/podcast-editor', module: ''},
                                  { name: 'Publications', path: '/publication-editor', module: ''},
                                  { name: 'Calendars', path: '/calendar-editor', module: ''}
                                ];
                                setPages(pages.filter((page) => (!page.module || modules.indexOf(page.module) !== -1)));
                                return {...user, modules, canPublish: false }; 
                              });
                          }
                        });
    let everyoneFinish = await Promise.all([pressReleaseLists, userProfile]);
    return { pressReleaseLists: everyoneFinish[0], userProfile: everyoneFinish[1] };
  }
  
  return (
    <SnackbarProvider>
      <StateProvider initialState={initialState} initFn={init}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <BrowserRouter basename={'/news'}>
              <ScrollToTop/>
              <AppSkeleton pages={pages}>
                <Routes>
                  <Route exact path={`/`} element={<HomePage />}></Route>
                  <Route path={`/press-release-editor`}>
                    <Route path="list/:id" element={
                      <Suspense fallback={<CircularProgress/>}><ListPage/></Suspense>
                    }></Route>
                    <Route path=":id" element={
                      <Suspense fallback={<CircularProgress/>}><EditPage/></Suspense>
                    }></Route>
                    <Route path="" element={
                      <Suspense fallback={<CircularProgress/>}><PressReleasesHomePage/></Suspense>
                    }></Route>
                  </Route>
                  <Route path={`/podcast-editor/*`} element={
                      <Suspense fallback={<CircularProgress/>}><Podcasts/></Suspense>
                    }></Route>
                  <Route path={`/publication-editor/*`} element={
                      <Suspense fallback={<CircularProgress/>}><Publications/></Suspense>
                    }></Route>
                  <Route path={`/calendar-editor/*`} element={
                      <Suspense fallback={<CircularProgress/>}><Calendars/></Suspense>
                    }></Route>
                  <Route path="*" element={NotFoundPage}/>
                </Routes>
              </AppSkeleton>
            </BrowserRouter>
          </ThemeProvider>
        </StyledEngineProvider>
      </StateProvider>
    </SnackbarProvider>
  );
}

export default App;